import { Education } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { MarketCountryCode } from '@axo/shared/types';
import { ButtonSet } from '@axo/ui-core/components/Button';
import { FormProvider, useForm } from 'react-hook-form';
import { Form } from '../../../../../components/Form';
import { Navigation } from '../../../../../components/Navigation';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import useInitiatedTracking from '../../../../../hooks/tracking/useInitiatedTracking';
import { Step2Data } from '../../FormData.no.types';
import { CitizenFormGroup } from './CitizenFormGroup';
import { EmploymentFormGroup } from './EmploymentFormGroup';
import { IncomeFormGroup } from './IncomeFormGroup';
import { PersonFormGroup } from './PersonFormGroup';

const touchedFieldsOverride: Array<keyof Step2Data> = [
  'Frontend/IsNorwegian',
  'LoanApplication/Education',
  'LoanApplication/Employer',
  'LoanApplication/EmploymentStatusSince',
  'LoanApplication/LivedInMarketCountrySince',
];

export const Step2 = () => {
  const { t } = useTranslation();

  const { onChange, onPrevStep, onSubmit } = useAxoFormContext<Step2Data>();

  const form = useForm({
    defaultValues: {
      'Frontend/IsNorwegian': 'Yes',
      'LoanApplication/Citizenship': MarketCountryCode.Norway,
      'LoanApplication/Education': Education.EducationHigherEducation,
    },
    mode: 'onBlur',
  });

  const {
    formState: { isSubmitting, touchedFields },
  } = form;

  useInitiatedTracking({
    shouldTriggerOnInitiated: Object.keys(touchedFields).length > 0,
  });

  return (
    <FormProvider {...form}>
      <Form
        onSubmit={onSubmit}
        onChange={onChange}
        touchedFieldsOverride={touchedFieldsOverride}
      >
        <PersonFormGroup />

        <EmploymentFormGroup />

        <CitizenFormGroup />

        <IncomeFormGroup />

        <ButtonSet justify={'space-between'} responsive>
          <Navigation.Back onClick={onPrevStep}>{t('back')}</Navigation.Back>
          <Navigation.Continue loading={isSubmitting}>
            {t('continue')}
          </Navigation.Continue>
        </ButtonSet>
      </Form>
    </FormProvider>
  );
};
